<template>
  <el-dialog
    :close-on-click-modal="false"
    title="支付到付款"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <p class="totalAmount">
        现金：<span class="primary">{{originData.arrivePaymentFee / 100}}</span>元
      </p>
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
      />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  orderPayPay,
  orderReturnPay,
} from 'api/operate';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '结果',
            value: 'orderPayArriveState',
            type: 'radio',
            placeholder: '请选择结果',
            default: 1,
            options: [
              {
                label: '审核通过',
                value: 1,
              },
              {
                label: '审核不通过',
                value: 2,
              },
            ],
          },
          {
            label: '备注',
            value: 'verifyDesc',
            type: 'input',
            placeholder: '请输入备注',
            attr: {
              type: 'textarea',
            },
          },
        ],
        rules: { // 表单验证规则
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.originData = item;
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      let fn = orderPayPay;
      if (form.orderPayArriveState === 2) {
        fn = orderReturnPay;
      }
      const res = await fn({
        orderId: this.originData.orderId,
        auditCode: 300007,
        verifyDesc: form.verifyDesc,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style scope lang="scss">
.totalAmount{
  margin-bottom: 16px;
}
</style>
